import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle2, Loader2, XCircle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('checking');
  const [courseName, setCourseSlug] = useState('');
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (!sessionId) { setStatus('error'); return; }
    let attempts = 0;
    const poll = async () => {
      if (attempts >= 5) { setStatus('timeout'); return; }
      attempts++;
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`, { withCredentials: true });
        if (data.payment_status === 'paid') {
          setStatus('success');
          setCourseSlug(data.course_slug || '');
          return;
        }
        if (data.status === 'expired') { setStatus('expired'); return; }
        setTimeout(poll, 2000);
      } catch {
        setTimeout(poll, 2000);
      }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6">
      <div data-testid="payment-status" className="text-center max-w-md">
        {status === 'checking' && (
          <>
            <Loader2 className="w-12 h-12 text-[#0077B6] mx-auto mb-6 animate-spin" strokeWidth={1.5} />
            <h1 className="text-2xl font-bold tracking-tight mb-2" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>Processing Payment...</h1>
            <p className="text-sm text-zinc-200">Please wait while we confirm your payment.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle2 className="w-12 h-12 text-green-500 mx-auto mb-6" strokeWidth={1.5} />
            <h1 className="text-2xl font-bold tracking-tight mb-2" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>Payment Successful!</h1>
            <p className="text-sm text-zinc-200 mb-8">You've been enrolled{courseName && ` in ${courseName}`}. Welcome to Institute of Analytics USA&trade;!</p>
            <Link to="/dashboard" className="brand-btn text-sm px-8 py-3 inline-block" data-testid="go-to-dashboard">Go to Dashboard</Link>
          </>
        )}
        {(status === 'error' || status === 'timeout' || status === 'expired') && (
          <>
            <XCircle className="w-12 h-12 text-red-500 mx-auto mb-6" strokeWidth={1.5} />
            <h1 className="text-2xl font-bold tracking-tight mb-2" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>
              {status === 'expired' ? 'Payment Expired' : 'Payment Issue'}
            </h1>
            <p className="text-sm text-zinc-200 mb-8">
              {status === 'expired' ? 'Your payment session has expired.' : 'There was an issue verifying your payment. If you were charged, please contact support.'}
            </p>
            <Link to="/dashboard" className="brand-btn text-sm px-8 py-3 inline-block">Back to Dashboard</Link>
          </>
        )}
      </div>
    </div>
  );
}
